import { Loading, isSuccess, useDynamicConfig } from "@dgs/core";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useNavigate, useParams } from "react-router";
import { eventService } from "../../api/eventService";
import { mapEventToFormValues } from "./eventFormUtils";
import { SaveEvent } from "./SaveEvent";

interface Props {
	basePath: string;
	keysToInvalidate?: string[][];
}
export const UpdateEventTypePage: FC<Props> = ({ basePath, keysToInvalidate }) => {
	const { eventId = "" } = useParams();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { defaultCurrency } = useDynamicConfig();

	const { data: event, isLoading } = useQuery({
		queryKey: eventService.showKey(eventId),
		queryFn: () => eventService.show(eventId).then((x) => x.data.data),
	});

	if (isLoading || !event) {
		return <Loading />;
	}
	return (
		<SaveEvent
			initialValues={mapEventToFormValues(event, defaultCurrency)}
			onSubmit={async (request) => {
				const response = await eventService.update(eventId, request);
				keysToInvalidate && keysToInvalidate.forEach((key) => void queryClient.invalidateQueries({ queryKey: key }));

				if (isSuccess(response)) {
					navigate(`/${basePath}/${eventId}`);
				}
			}}
		/>
	);
};
